import React from 'react';

const ProductDetails = () => {
  return (
    <div className="product-details">
      <h1>Product Title</h1>
      <p>Description of the product goes here.</p>
      <p>Price: $0.00</p>
      <button>Add to Cart</button>
    </div>
  );
};

export default ProductDetails;